// Источник истины для дизайн-токенов Backupex. См. DESIGN_BRIEF §7 и
// backupex-design/project/css/app.css.
// Все Naive overrides читают значения отсюда.

export const brand = {
  primary: '#2563EB',
  primaryHover: '#1D4ED8',
  primaryPressed: '#1E40AF',
  primaryWeak: 'rgba(37, 99, 235, 0.10)',
}

export const status = {
  success: '#16A34A',
  successWeak: 'rgba(22, 163, 74, 0.12)',
  warning: '#D97706',
  warningWeak: 'rgba(217, 119, 6, 0.14)',
  error: '#DC2626',
  errorWeak: 'rgba(220, 38, 38, 0.12)',
  info: '#0EA5E9',
  infoWeak: 'rgba(14, 165, 233, 0.14)',
}

export const light = {
  bg: '#F5F6F8',
  surface: '#FFFFFF',
  surface2: '#F7F8FA',
  surfaceHover: '#F1F3F5',
  border: '#E5E7EB',
  borderStrong: '#D6D9DE',
  text: '#181B20',
  text2: '#5A626D',
  text3: '#9097A1',
}

export const dark = {
  bg: '#0D0D10',
  surface: '#161619',
  surface2: '#1C1C20',
  surfaceHover: '#212126',
  border: '#27272C',
  borderStrong: '#33333A',
  text: '#E7E7EA',
  text2: '#9A9AA3',
  text3: '#6A6A73',
}

export const radii = {
  control: 4,
  card: 8,
  modal: 10,
}

export const typography = {
  fontFamily: 'Inter, -apple-system, "Segoe UI", Roboto, sans-serif',
  monoFamily: '"JetBrains Mono", Menlo, monospace',
  bodyFontSize: 14,
  bodyLineHeight: 1.45,
}

// Унифицированные размеры shell — топбар 56px, сайдбар 240/64.
export const shell = {
  topbarHeight: 56,
  sidebarWidth: 240,
  sidebarCollapsedWidth: 64,
}
